import type { ConfigType } from '@plone/registry';
import installSettings from './config/settings';

import './theme';

// Policy blocks
import CallToActionBlock from './components/Blocks/CallToAction';
import CoverBlock from './components/Blocks/Cover';
import CardBlock from './components/Blocks/Card';
import DividerBlock from './components/Blocks/Divider';
import TestimonialBlock from './components/Blocks/Testimonial';

import GTMWrapper from './components/GTM/GTMWrapper';
import MobileNavigationBrand from './components/Header/MobileNavigationBrand';
import addStyleMenuTextColors from './editor/plugins/TextColors';
import SearchForm from './components/Search/SearchForm';

function applyConfig(config: ConfigType) {
  installSettings(config);

  config.settings = {
    ...config.settings,
    appExtras: [
      ...(config.settings.appExtras || []),
      {
        match: '',
        component: GTMWrapper,
      },
    ],
  };
  config = addStyleMenuTextColors(config);

  config.registerComponent({
    name: 'MobileNavigationBrand',
    component: MobileNavigationBrand,
  });

  config.registerComponent({
    name: 'SiteSearch',
    component: SearchForm,
  });

  config.blocks.groupBlocksOrder = [
    ...(config.blocks.groupBlocksOrder || []),
    {
      id: 'wildcard',
      title: 'Wildcard',
    },
  ];

  const blocksConfig = config.blocks.blocksConfig as Record<string, any>;

  // Policy-specific block overrides
  blocksConfig.cover = CoverBlock;
  blocksConfig.testimonial = TestimonialBlock;

  // Wildcard block variations
  blocksConfig.w_call_to_action = CallToActionBlock;
  blocksConfig.w_card = CardBlock;
  blocksConfig.w_divider = DividerBlock;

  return config;
}

export default applyConfig;